export const NutritionLabelRoundingProfile = {
  Standard: 0,
  Fsis: 1,
  Supplement: 2,
} as const;

export type NutritionLabelRoundingProfileValue =
  typeof NutritionLabelRoundingProfile[keyof typeof NutritionLabelRoundingProfile];